import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 via-background-50 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 pt-32 pb-16 flex flex-col items-center text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6 tracking-wide">
          海量韩漫 · 完全免费 · 每日更新
        </span>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight max-w-3xl">
          发现你最爱看的
          <br />
          <span className="text-primary-500">韩国漫画</span>
        </h1>

        <p className="mt-6 text-foreground-500 text-base md:text-lg max-w-xl leading-relaxed">
          汇聚全网优质韩漫资源，免费在线阅读。从恋爱甜宠到奇幻冒险，
          每日更新热门连载，一键追更不迷路。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full transition-all duration-200 flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            立即探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/#hot"
            className="px-8 py-3.5 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            热门推荐
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-4 md:gap-6 w-full max-w-2xl">
          {[
            { img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%20young%20couple%20sweet%20moment%20warm%20lighting%20soft%20illustration%20style%20clean%20simple%20background%20manhwa%20art%20beautiful%20character%20design%20professional%20digital%20painting&width=400&height=560&seq=hero-card-01&orientation=portrait', label: '恋爱甜宠' },
            { img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20action%20comic%20cover%20warrior%20with%20sword%20epic%20adventure%20dramatic%20lighting%20dynamic%20composition%20manhwa%20art%20style%20clean%20simple%20background%20professional%20digital%20illustration%20stunning%20visual&width=400&height=560&seq=hero-card-02&orientation=portrait', label: '奇幻冒险' },
            { img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20thriller%20comic%20cover%20detective%20in%20trench%20coat%20dark%20moody%20atmosphere%20suspenseful%20scene%20manhwa%20art%20style%20clean%20simple%20background%20professional%20digital%20illustration%20cinematic%20lighting&width=400&height=560&seq=hero-card-03&orientation=portrait', label: '悬疑推理' },
          ].map((card, idx) => (
            <Link
              key={card.label}
              to="/category"
              className={`relative group cursor-pointer transition-all duration-500 hover:z-20 ${
                idx === 1 ? 'z-10 -mt-8 md:-mt-12' : idx === 0 ? '-rotate-3' : 'rotate-3'
              }`}
            >
              <div className="relative overflow-hidden rounded-xl bg-background-100 aspect-[3/4]">
                <img
                  src={card.img}
                  alt={card.label}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  title={card.label}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="text-background-50 text-xs md:text-sm font-medium">
                    {card.label}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-foreground-400 text-2xl"></i>
      </div>
    </section>
  );
}